import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=035ac6cd&"
import script from "./Events.vue?vue&type=script&lang=ts&"
export * from "./Events.vue?vue&type=script&lang=ts&"
import style0 from "./Events.vue?vue&type=style&index=0&id=035ac6cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports